import { render, staticRenderFns } from "./ManufactureAndExpirationInfo.vue?vue&type=template&id=15fe7b0d&"
import script from "./ManufactureAndExpirationInfo.vue?vue&type=script&lang=ts&"
export * from "./ManufactureAndExpirationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports